import Vue from 'vue'
import Vuex from 'vuex'

import user from './userinfo'
import systems from './systems'
import appUpdate from './appUpdate'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        user,
        systems,
        appUpdate,
    }
})
